import type { GameState } from '../game/types'

export function EventLog({ g }: { g: GameState }) {
  return (
    <div className="log card">
      <div className="panel-title">
        <span>บันทึกเหตุการณ์</span>
        {g.globalEffects.length > 0 && <span className="pill bad">🌍 {g.globalEffects.length} เอฟเฟกต์โลก</span>}
      </div>

      {g.globalEffects.length > 0 && (
        <div className="global-effects">
          {g.globalEffects.map((e) => (
            <span key={e.uid} className={`eff ${e.good ? 'good' : 'bad'}`}>
              {e.emoji} {e.label} <b>{e.turnsLeft} รอบ</b>
            </span>
          ))}
        </div>
      )}

      <ul className="log-list">
        {g.log.map((entry) => {
          const who = entry.playerId !== null ? g.players[entry.playerId] : null
          return (
            <li key={entry.id} className={`log-item ${entry.tone}`}>
              <span className="log-emoji">{entry.emoji}</span>
              <span className="log-text">
                {entry.text}
                <em className="faint tiny"> · รอบ {entry.round}</em>
              </span>
              {who && <span className="log-dot" style={{ background: who.character.color }} />}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
